	export enum ClaimInsuredProviderAcceptAssignmentEnum {
		A = 1,
		B = 2,
		C = 3
	}
